import { useEffect } from "react";

/**
 * Safety net for a silently dead Realtime socket.
 *
 * useScreenConfig subscribes to postgres_changes for instant pushes, but a
 * WebSocket can stop delivering without the browser ever firing `offline`
 * (NAT timeout, the TV's network stack sleeping). The failure is invisible:
 * the screen keeps playing, so nobody notices the menu is stale until a
 * customer reads the wrong price.
 *
 * Re-fetching on a slow interval bounds that exposure to one interval rather
 * than days. It costs one tiny query per screen per interval — negligible
 * next to the 10s poll this rewrite replaced.
 */

const WATCHDOG_INTERVAL_MS = 10 * 60_000; // 10 minutes

export function useConfigWatchdog(onRefetch: () => Promise<boolean>) {
  useEffect(() => {
    const id = setInterval(() => {
      // A failed fetch is already logged and retried by the caller; the
      // subscription stays live either way, so nothing to handle here.
      void onRefetch();
    }, WATCHDOG_INTERVAL_MS);
    return () => clearInterval(id);
  }, [onRefetch]);
}
